var module = angular.module('octopusApp.infrastructure');

// Allows other parties to register 'plugins' that provide the view and edit experience for
// custom deployment actions and conventions.
//
//   var module = angular.module('myPlugin', [], function(pluginRegistry) {
//      pluginRegistry.registerDeploymentAction("Octopus.TentaclePackage", {
//        title: "Deploy a NuGet package",               // Display text for users adding the step
//        summary: "Deploys a NuGet package...",         // Help text to show
//        summaryTemplateUrl: "area/foo/bar.html",       // Template for a short summary on the process overview page
//        summaryLink: function (scope, element) {       // Angular directive-style link function
//          var action = scope.action;                   // Get the action we are rendering
//          var step = scope.step;                       // Get the step we are rendering
//          var jQueryElement = element;                 // The HTML element for the bar.html we just inserted
//        },
//        editTemplate: "area/bar/baz.html"              // Template for editing
//      });
//
//      pluginRegistry.registerFeature("Octopus.Features.CustomPackageDirectory", {
//        isEnabled: function(action, step) {  },
//        enable: function(action, step) {  },
//        disable: function(action, step) {  },
//        editTemplateUrl: "area/foo/bar.html",
//        editLink: function(scope, element) { }
//      });
//   });

module.factory('pluginRegistry', function ($injector) {
  var data = {};
  data.registeredActions = {};
  data.registeredFeatures = {};

  var resolve = function (container, key, callback) {
    var result = $injector.invoke(container[key]);
    callback(result, key);
    return result;
  };

  var resolveAll = function (container, callback) {
    return _.chain(container).map(function (registration, key) {
      return resolve(container, key, callback);
    }).sortBy(function (item) { return item.priority; }).value();
  };

  var registry = {};
  registry.registerDeploymentAction = function(actionType, registration) {
    data.registeredActions[actionType] = registration;
  };
  registry.getDeploymentAction = function(actionType) {
    return resolve(data.registeredActions, actionType, function (feature, name) { feature.actionType = name; });
  };
  registry.getAllActions = function() {
    return resolveAll(data.registeredActions, function (feature, name) { feature.actionType = name; });
  };
  registry.registerFeature = function(featureName, registration) {
    data.registeredFeatures[featureName] = registration;
  };
  registry.getFeature = function(featureName) {
    return resolve(data.registeredFeatures, featureName, function (feature, name) { feature.featureName = name; });
  };
  registry.getAllFeatures = function() {
    return resolveAll(data.registeredFeatures, function (feature, name) { feature.featureName = name; });
  };
  registry.hasFeaturesForAction = function(actionType) {
    var actionPlugin = registry.getDeploymentAction(actionType);
    return _.chain(registry.getAllFeatures()).filter(function (f) { return actionPlugin.features && actionPlugin.features.optional && _.contains(actionPlugin.features.optional, f.featureName); }).value().length > 0;
  };

  return registry;
});


//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/services/plugin_registry.js
// module id = 7941681443789952
// module chunks = 1